import { Injectable } from '@angular/core';
const SMALL_WIDTH_BREAKPOINT = 720;

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  private mediaMatcher: MediaQueryList = matchMedia(
    `(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`
  );

  constructor() {}
  isMobile(): boolean {
    return this.mediaMatcher.matches;
  }
}
